import React from 'react'
import { MDXProvider } from '@mdx-js/react'
import { format } from 'date-fns'

import SEO from './seo'

import "./layout.css"

const components = {}

export default function Layout(props) {
  const { frontmatter } = props.pageContext
  return (
    <MDXProvider components={components}>
      <SEO lang={'en'} title={frontmatter.title}/>
      <style>{`#mdx-doc a, #mdx-doc a:visited {color: black}`}</style>
      <section id="mdx-doc" style={{margin:'.8em'}}>
        <h1>{frontmatter.title}</h1>
        {frontmatter.wip && <p style={{backgroundColor:'#ddd', padding:'.3em', borderRadius:'.2em'}}>⚠️ This page is a Work in Progress</p>}
        {props.children}
        {(frontmatter.date || frontmatter.edited) && <footer>Last edited on: {format(new Date(frontmatter.edited||frontmatter.date),'do MMM yyyy')}</footer>}
      </section>
    </MDXProvider>
  )
}